import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3fd915eb")

_pushScopeId("data-v-3fd915eb")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "price" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Open ")
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" High ")
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Low ")
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Close ")
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Chg ")
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Chg% ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.crosshair)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: "line v",
          style: {top: `${_ctx.crosshair ? _ctx.crosshair.y : 0}px`}
        }, [
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.crosshair.c.toFixed(5)), 1)
        ], 4),
        _createVNode("div", {
          class: "line h",
          style: {left: `${_ctx.crosshair ? _ctx.crosshair.x : 0}px`}
        }, null, 4),
        _createVNode("div", {
          class: "board f-bold",
          style: {[_ctx.crosshair.x < 100 ? 'right' : 'left']: 0}
        }, [
          _createVNode("p", null, _toDisplayString(_ctx.formatTime(_ctx.crosshair.bar.t)), 1),
          _createVNode("p", _hoisted_3, [
            _hoisted_4,
            _createVNode("span", {
              class: _ctx.getColorClass(_ctx.crosshair.bar.o)
            }, _toDisplayString(_ctx.crosshair.bar.o), 3)
          ]),
          _createVNode("p", _hoisted_5, [
            _hoisted_6,
            _createVNode("span", {
              class: _ctx.getColorClass(_ctx.crosshair.bar.h)
            }, _toDisplayString(_ctx.crosshair.bar.h), 3)
          ]),
          _createVNode("p", _hoisted_7, [
            _hoisted_8,
            _createVNode("span", {
              class: _ctx.getColorClass(_ctx.crosshair.bar.l)
            }, _toDisplayString(_ctx.crosshair.bar.l), 3)
          ]),
          _createVNode("p", _hoisted_9, [
            _hoisted_10,
            _createVNode("span", {
              class: _ctx.getColorClass(_ctx.crosshair.bar.c)
            }, _toDisplayString(_ctx.crosshair.bar.c), 3)
          ]),
          _createVNode("p", _hoisted_11, [
            _hoisted_12,
            _createVNode("span", {
              class: _ctx.getColorClass(_ctx.crosshair.bar.c)
            }, _toDisplayString(_ctx.crosshair.bar.chg), 3)
          ]),
          _createVNode("p", _hoisted_13, [
            _hoisted_14,
            _createVNode("span", {
              class: _ctx.getColorClass(_ctx.crosshair.bar.c)
            }, _toDisplayString(_ctx.crosshair.bar['chg%']) + "%", 3)
          ])
        ], 4)
      ]))
    : _createCommentVNode("", true)
})